import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/ChevronUp.svg?component
var ChevronUp_exports = /* @__PURE__ */ __exportAll({
	default: () => ChevronUp_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m18 15-6-6-6 6"
	}, null, -1)])]);
}
var ChevronUp_default = { render: render$1 };
//#endregion
export { ChevronUp_exports, ChevronUp_default as default, render$1 as render };

//# sourceMappingURL=ChevronUp.svg.virtual.js.map